import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ui-menu-item',
  templateUrl: './ui-menu-item.component.html',
  styleUrls: ['./ui-menu-item.component.scss']
})
export class UIMenuItemComponent implements OnInit {
  @Input() text: string;
  @Input() icon: string;
  @Input() badge: string;

  constructor() { }

  ngOnInit(): void {
  }

}
